import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import PageHero from "@/components/PageHero";
import { ArrowRight } from "lucide-react";

export default function Blog() {
  const { settings } = useSettings();
  const [posts, setPosts] = useState([]);
  const [category, setCategory] = useState("all");
  useEffect(() => { api.get("/blog?status=published").then((r) => setPosts(r.data)); }, []);

  const categories = useMemo(() => ["all", ...Array.from(new Set(posts.map((p) => p.category).filter(Boolean)))], [posts]);
  const filtered = category === "all" ? posts : posts.filter((p) => p.category === category);

  return (
    <div className="bg-[color:var(--marupiara-ivory)]">
      <PageHero image={settings.blog_hero_image} overline="Blog" title="Conteúdo editorial." />
      <section className="py-8 border-b border-neutral-200 bg-[color:var(--marupiara-cream)]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-wrap gap-2">
          {categories.map((c) => (
            <button key={c} data-testid={`blog-cat-${c}`} onClick={() => setCategory(c)} className={`px-4 py-2 text-xs uppercase tracking-wider transition-colors ${category === c ? "bg-[color:var(--marupiara-obsidian)] text-[color:var(--marupiara-gold)]" : "bg-white border border-neutral-300 hover:border-[color:var(--marupiara-gold-dark)] text-neutral-700"}`}>
              {c === "all" ? "Todos" : c}
            </button>
          ))}
        </div>
      </section>
      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {filtered.map((p) => (
            <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-post-${p.id}`} className="group block">
              <div className="aspect-[16/10] overflow-hidden bg-neutral-200 mb-4">
                <img src={p.cover_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="overline text-[color:var(--marupiara-gold-dark)] mb-2">{p.category}</div>
              <h3 className="font-serif text-2xl text-[color:var(--marupiara-obsidian)] group-hover:text-[color:var(--marupiara-gold-dark)] transition-colors leading-tight mb-2">{p.title}</h3>
              <p className="text-sm text-[color:var(--marupiara-text-on-light-muted)] line-clamp-3">{p.excerpt}</p>
              <div className="mt-3 flex items-center gap-2 text-xs text-[color:var(--marupiara-gold-dark)]">Ler artigo <ArrowRight size={12} /></div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
